// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"392":"994b0b37","476":"994b0b37","567":"635011d2"}[chunkId] + ".chunk.css";
};